import React, { useMemo } from "react";
import { CircleLoader } from "../../icons/Loaders";

import "./StoryValueEngine.scss";

type StoryValueEngineProps = {
  reach?: number,
  socialScore?: number,
  author?: string,
  sections?: Array<string>|string,
  loading?: boolean,
};

const StoryValueEngine = ({ reach, socialScore, author, sections, loading }: StoryValueEngineProps) => {
  const formattedSections = useMemo(() => {
    if (!sections) {
      return '';
    }

    return Array.isArray(sections) ? sections.join(', ') : sections;
  }, [sections]);

  return (
    <div className="story-value-engine">
      <h3>Story Value Engine</h3>
      <div className="story-value-engine-table">
        <div className="details-container-title">Predictions</div>
        <div className="details-container">
          <div className="section-title">Reach</div>
          {loading ? (
            <CircleLoader width="40px" height="40px" />
          ) : reach ? (
            <div className="section-data">{reach}</div>
          ) : (
            <div className="data-not-available">Not yet available</div>
          )}
        </div>
        <div className="details-container">
          <div className="section-title">Social Score</div>
          {loading ? (
            <CircleLoader width="40px" height="40px" />
          ) : socialScore ? (
            <div className="section-data">{socialScore}</div>
          ) : (
            <div className="data-not-available">Not yet available</div>
          )}
        </div>
        <div className="details-container">
          <div className="section-title">Author</div>
          {loading ? (
            <CircleLoader width="40px" height="40px" />
          ) : author ? (
            <div className="section-data">{author}</div>
          ) : (
            <div className="data-not-available">Not yet available</div>
          )}
        </div>
        <div className="details-container">
          <div className="section-title">Sections</div>
          {loading ? (
            <CircleLoader width="40px" height="40px" />
          ) : sections ? (
            <div className="section-data">{formattedSections}</div>
          ) : (
            <div className="data-not-available">Not yet available</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StoryValueEngine;
